import React, { useEffect, useState } from "react";
import { Box, SystemProps } from "@storyofams/react-ui";

import { useRouter } from "next/router";
import { formatShopifyIdForTracking, getProductClickOrigin, track } from "~lib";
import { Text } from "../..";
import { ProductByHandleQuery } from "../../../lib/shopify/sdk";

import { ActionPannel } from "./ActionPanel";
import { BackInStock } from "./ActionPanel/BackInStock";
import { Price } from "./Price";

interface Props {
  product: ProductByHandleQuery["productByHandle"];
  tiered_discount_enabler?: boolean;
  isUpsellDisabled?: boolean;
  content?: any;
}
export const VariantSelection = ({
  product,
  isUpsellDisabled,
  content,
  ...props
}: Props & SystemProps) => {
  const { query } = useRouter();
  const [quantity, setQuantity] = useState(1);
  const currentVariant = product.variants?.edges?.find(
    ({ node }) => node.id === `gid://shopify/ProductVariant/${query?.variantId}`
  )?.node;
  const hasOneVariant = currentVariant && product.variants.edges.length === 1;
  useEffect(() => {
    if (currentVariant) {
      track({
        event: "dl_view_item",
        ecommerce: {
          currencyCode: "EUR",
          detail: {
            actionField: {
              list: getProductClickOrigin(
                formatShopifyIdForTracking(product.id)
              ),
            },
            products: [
              {
                name: product.title || "",
                id: currentVariant.sku || "",
                product_id: formatShopifyIdForTracking(product.id),
                variant_id: formatShopifyIdForTracking(currentVariant.id) || "",
                image: currentVariant.image?.originalSrc || "",
                price: currentVariant.priceV2?.amount,
                brand: product.vendor || "",
                variant: currentVariant.title || "",
                category: product.productType,
                list: getProductClickOrigin(
                  formatShopifyIdForTracking(product.id)
                ),
                compare_at_price: String(
                  currentVariant.compareAtPriceV2?.amount
                ),
                inventory: String(currentVariant.quantityAvailable),
              },
            ],
          },
        },
      });
    }
  }, [currentVariant]);
  return (
    <Box mt={5} width="100%" {...props}>
      <Price
        currentVariant={currentVariant}
        product={product}
        quantity={quantity}
      />
      <Text mb={1} fontSize={"14px"} color="grey600">
        Aantal
      </Text>
      <ActionPannel
        quantity={quantity}
        setQuantity={setQuantity}
        product={product}
        foundVariant={currentVariant}
        isUpsellDisabled={isUpsellDisabled}
      />
      {hasOneVariant && !currentVariant?.availableForSale && (
        <Box
          mt={1}
          pb={["7px", "11px"]}
          pt={[0, "3px"]}
          px={["6px", "16px"]}
          border={"1px solid #E2DFDF"}
          borderRadius={"8px"}
        >
          <BackInStock id={product.id} variantId={currentVariant.id} />
        </Box>
      )}
      <Box
        p={2}
        display={["block", "none"]}
        position={"fixed"}
        bottom={0}
        left={0}
        zIndex={100}
        width={"100%"}
        backgroundColor={"white"}
      >
        <ActionPannel
          quantity={quantity}
          setQuantity={setQuantity}
          product={product}
          foundVariant={currentVariant}
          isUpsellDisabled={isUpsellDisabled}
          isFixed
        />
      </Box>
    </Box>
  );
};
